export var TimeFormatsConstants = {
    TWELVE_HOUR: 'h:mm a',
    TWELVE_HOUR_NO_MERIDIAN: 'h:mm',
    TWENTY_FOUR_HOUR: 'HH:mm',
};
/* @TODO Update this to be lowercase */
export var ComposerMode = {
    CREATE: 'create',
    EDIT: 'edit',
};
/**
 * Abstract buffer event types used by the shared EventComposer component.
 * These are mapped to app-specific Amplitude event names at the application level.
 */
export var BufferEventType = {
    ADDED_BUFFER: 'addBuffer',
    REMOVED_BUFFER: 'removeBuffer',
    CREATED_BUFFER_EVENT: 'createdBufferEvent',
    DETECTED_BUFFER_CONFLICT: 'detectedBufferConflict',
};
/**
 * Abstract analytics event types emitted by the shared EventComposer.
 * These are mapped to app-specific Amplitude event names at the application
 * level (see `onTrackComposerEvent`), mirroring the `BufferEventType` pattern.
 */
export var ComposerAnalyticsEvent = {
    /** Composer mounted. Metadata: `{ mode }`. */
    COMPOSER_OPENED: 'composerOpened',
    /** Create succeeded. Metadata: `{ spaceCount, inviteeCount, externalInviteeCount, hasRecurrence, isRequestOnly }`. */
    EVENT_CREATED: 'eventCreated',
    /** Update succeeded. Metadata: `{ updatedAsSpace, recurring }`. */
    EVENT_UPDATED: 'eventUpdated',
    /** Create/update API call failed. Metadata: `{ mode }`. */
    EVENT_SYNC_FAILED: 'eventSyncFailed',
    /** Composer closed without saving. Metadata: `{ mode, isDirty }`. */
    COMPOSER_ABANDONED: 'composerAbandoned',
    /** "Add space" sider opened. Metadata: `{ mode }`. */
    OPENED_ADD_SPACE_SIDER: 'openedAddSpaceSider',
    /** Space added via the add-space sider. Metadata: `{ spaceId, isRequestOnly, spaceCount, wasSuggested: false }`. */
    ADDED_SPACE: 'addedSpace',
    /** Suggested space accepted. Metadata: `{ spaceId, spaceCount, wasSuggested: true }`. */
    ADDED_SUGGESTED_SPACE: 'addedSuggestedSpace',
    /** Suggested-times drawer opened. Metadata: `{ mode }`. */
    OPENED_SUGGESTED_TIMES_SIDER: 'openedSuggestedTimesSider',
    /** A suggested time was applied. Metadata: `{ surface: 'prompt' | 'drawer' }`. */
    SELECTED_SUGGESTED_TIME: 'selectedSuggestedTime',
    /** A recurrence rule was selected. Metadata: `{ rule }`. */
    SELECTED_RECURRENCE: 'selectedRecurrence',
    /** An invitee outside the org (email-only, no user_id) was added. Metadata: `{ inviteeCount }`. */
    ADDED_EXTERNAL_INVITEE: 'addedExternalInvitee',
    /** Event canceled/deleted from EventDetails. Metadata: `{ canceledAsSpace, recurring }`. */
    EVENT_CANCELED: 'eventCanceled',
    /** A space was removed from the event in the composer. Metadata: `{ spaceId, mode }`. */
    REMOVED_SPACE: 'removedSpace',
};
/**
 * Container the EventComposer renders itself inside.
 *
 * - `drawer` (default): wraps the body in an Ant Design `Drawer`. This
 *   matches the legacy behavior — the Drawer portals to document.body and
 *   floats above the page.
 * - `inline`: renders the body inline with its own header (title + close
 *   button), with no portal. Use this when you want to host the composer
 *   inside your own layout primitive (e.g. the shell's right-hand `Sider`),
 *   so the composer occupies the layout slot rather than floating over it.
 */
export var ComposerContainerMode = {
    DRAWER: 'drawer',
    INLINE: 'inline',
};
